import React from 'react';
import { STATE_TONE, TONE_CLASSES } from './format';

export default function Badge({ tone, state, children, pulse = false, className = '' }) {
  const resolvedTone = tone || STATE_TONE[state] || 'zinc';
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-md px-1.5 py-0.5 text-[10px] font-semibold ring-1 ring-inset ${TONE_CLASSES[resolvedTone]} ${className}`}
    >
      {pulse ? (
        <span className="relative flex h-1.5 w-1.5">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-current opacity-60" />
          <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-current" />
        </span>
      ) : null}
      {children ?? state}
    </span>
  );
}
